import { useState, useEffect } from "react";
import ConfigAPI from "../../services/ConfigAPI";

export default function ServiceTypeFilterSection() {
    const [filters, setFilters] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingFilter, setEditingFilter] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const [formData, setFormData] = useState({ label: '', value: '' });

    useEffect(() => {
        loadFilters();
    }, []);

    const loadFilters = async () => {
        try {
            setLoading(true);
            const response = await ConfigAPI.getServiceTypeFilters();
            if (response.success) setFilters(response.data);
        } catch (err) {
            setError("Erro ao carregar filtros");
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setFormData({ label: '', value: '' });
        setEditingFilter(null);
    };

    const handleEdit = (filter) => {
        setEditingFilter(filter);
        setFormData({ label: filter.label, value: filter.value });
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Deseja remover este filtro?')) return;
        try {
            setLoading(true);
            const response = await ConfigAPI.deleteServiceTypeFilter(id);
            if (response.success) {
                setSuccess("Filtro removido com sucesso");
                setTimeout(() => setSuccess(null), 3000);
                await loadFilters();
            }
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao remover filtro");
            setTimeout(() => setError(null), 3000);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        if (!formData.label.trim() || !formData.value.trim()) {
            alert('Label e valor são obrigatórios');
            return;
        }
        try {
            setLoading(true);
            const data = { label: formData.label.trim(), value: formData.value.trim() };
            let response;
            if (editingFilter) {
                response = await ConfigAPI.updateServiceTypeFilter(editingFilter._id, data);
            } else {
                response = await ConfigAPI.addServiceTypeFilter(data);
            }
            if (response.success) {
                setSuccess(editingFilter ? "Filtro atualizado com sucesso" : "Filtro adicionado com sucesso");
                setTimeout(() => setSuccess(null), 3000);
                resetForm();
                setShowModal(false);
                await loadFilters();
            }
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao salvar filtro");
            setTimeout(() => setError(null), 3000);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = async () => {
        if (!window.confirm('Restaurar filtros para o padrão (apenas CARD)?')) return;
        try {
            setLoading(true);
            const response = await ConfigAPI.resetServiceTypeFilters();
            if (response.success) {
                setSuccess("Filtros restaurados para o padrão");
                setTimeout(() => setSuccess(null), 3000);
                await loadFilters();
            }
        } catch (err) {
            setError(err.response?.data?.message || "Erro ao restaurar filtros");
            setTimeout(() => setError(null), 3000);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="section-content">
            <h1>Filtros de Tipo de Serviço</h1>
            <p className="card-description">
                Configure quais tipos de serviço são aceitos no LoadData. Apenas linhas cujo campo
                "Tipo Serviço" contenha um dos valores abaixo serão importadas.
            </p>

            {success && (
                <div className="alert-success">
                    <span>✓ {success}</span>
                </div>
            )}

            {error && (
                <div style={{
                    background: '#fee2e2',
                    color: '#dc2626',
                    padding: '1rem',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    fontWeight: '500'
                }}>
                    {error}
                </div>
            )}

            <div className="config-card">
                <div className="card-header">
                    <h3>Tipos Permitidos ({filters.length})</h3>
                    <div>
                        <button
                            className="btn-add"
                            onClick={() => { resetForm(); setShowModal(true); }}
                            disabled={loading}
                        >
                            + Novo Tipo
                        </button>
                        <button
                            className="btn-danger"
                            onClick={handleReset}
                            disabled={loading}
                        >
                            🔄 Restaurar Padrão
                        </button>
                    </div>
                </div>

                {loading && filters.length === 0 ? (
                    <div className="empty-state"><p>Carregando...</p></div>
                ) : filters.length === 0 ? (
                    <div className="empty-state">
                        <span className="empty-icon">🔍</span>
                        <p>Nenhum filtro configurado</p>
                        <p style={{ fontSize: '0.9rem', color: '#6b7280', marginTop: '0.5rem' }}>
                            Sem filtros, todos os tipos de serviço serão aceitos
                        </p>
                    </div>
                ) : (
                    <div className="columns-list">
                        {filters.map((filter) => (
                            <div key={filter._id} className="column-item">
                                <div className="column-main">
                                    <div className="column-header">
                                        <h4>{filter.label}</h4>
                                        <div className="column-badges">
                                            <span className="badge" style={{ background: '#dbeafe', color: '#1d4ed8' }}>
                                                contém "{filter.value}"
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="column-actions">
                                    <button
                                        className="btn-icon"
                                        onClick={() => handleEdit(filter)}
                                        disabled={loading}
                                        title="Editar"
                                    >
                                        ✏️
                                    </button>
                                    <button
                                        className="btn-icon btn-danger-icon"
                                        onClick={() => handleDelete(filter._id)}
                                        disabled={loading}
                                        title="Remover"
                                    >
                                        🗑️
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={() => { setShowModal(false); resetForm(); }}>
                    <div className="modal-content mapping-modal" onClick={(e) => e.stopPropagation()}>
                        <h2>{editingFilter ? 'Editar Tipo' : 'Novo Tipo de Serviço'}</h2>

                        <div className="form-group">
                            <label>Label *</label>
                            <input
                                type="text"
                                value={formData.label}
                                onChange={(e) => setFormData({ ...formData, label: e.target.value })}
                                placeholder="Ex: CARD, EXPRESS, SEDEX"
                                disabled={loading}
                            />
                            <p className="helper-text">Nome descritivo para exibição</p>
                        </div>

                        <div className="form-group">
                            <label>Valor (termo de filtro) *</label>
                            <input
                                type="text"
                                value={formData.value}
                                onChange={(e) => setFormData({ ...formData, value: e.target.value.toUpperCase() })}
                                placeholder="Ex: CARD"
                                className="monospace"
                                disabled={loading}
                            />
                            <p className="helper-text">
                                Texto que o campo "Tipo Serviço" deve <strong>conter</strong> para a linha ser aceita.
                                Salvo em maiúsculas automaticamente.
                            </p>
                        </div>

                        <div className="modal-actions">
                            <button
                                className="btn-secondary"
                                onClick={() => { setShowModal(false); resetForm(); }}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn-save"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? "Salvando..." : editingFilter ? 'Atualizar' : 'Adicionar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
